import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { LayoutRoutingModule } from './layout-routing.module';
import { SiteLayoutComponent } from './components/site-layout/site-layout.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { SiteNavbarComponent } from './components/site-navbar/site-navbar.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    AboutUsComponent,
    SiteLayoutComponent,
    BreadcrumbComponent,
    SiteNavbarComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    LayoutRoutingModule,
    LoadingBarHttpClientModule,
    SharedModule,
    RouterModule
  ],
  exports: [SiteLayoutComponent, BreadcrumbComponent],
})
export class LayoutModule { }
